export function applyExperimentsTransformer(config, variationStringsMap) {
    return function (labelProps, value) {
        var _a;
        const fullStringKey = labelProps.stringKey;
        if (!variationStringsMap.has(fullStringKey)) {
            return value;
        }
        const [experimentKey, variations] = variationStringsMap.get(fullStringKey);
        const variation = config.getVariation(experimentKey, labelProps);
        return (_a = variations[variation]) !== null && _a !== void 0 ? _a : value;
    };
}
//# sourceMappingURL=experimentsTransformer.js.map